import { firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'

const getUserProfileVerifiedIds = async ({ uid }) => {
	try {
		const userProfileDocRef = firestore.collection('userProfiles').doc(uid)

		// TODO: deletes - these subcollection queries need to be handled, do we just remove the collection (put it under deleted too)? rename it?
		const verifiedQuerySnap = await userProfileDocRef.collection('verified').get()

		return verifiedQuerySnap.docs.map(d => d.id)
	} catch (error) {
		throw errorOfType(errorTypes.UNKNOWNERROR, uid, error)
	}
}

export default getUserProfileVerifiedIds



// WEBPACK FOOTER //
// ./src/dataservices/getUserProfileVerifiedIds.js